"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var ProfilePhoto_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfilePhoto = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const uuid_1 = require("uuid");
const statusGetter_1 = require("../statusGetter");
const transformToDate_1 = require("../transformers/transformToDate");
let ProfilePhoto = ProfilePhoto_1 = class ProfilePhoto {
    fileId = (0, uuid_1.v4)();
    optimizedFileId;
    acceptedAt;
    declinedAt;
    declinationReason;
    get status() {
        return (0, statusGetter_1.statusGetter)(this, ProfilePhoto_1, legacy_enums_1.ProfilePhotoStatus);
    }
    static statusPrototype(status) {
        const defined = new Date();
        switch (status) {
            case legacy_enums_1.ProfilePhotoStatus.Declined:
                return { declinedAt: defined };
            case legacy_enums_1.ProfilePhotoStatus.Accepted:
                return {
                    acceptedAt: defined,
                    declinedAt: undefined,
                };
            case legacy_enums_1.ProfilePhotoStatus.Pending:
            default:
                return {
                    declinedAt: undefined,
                    acceptedAt: undefined,
                };
        }
    }
};
exports.ProfilePhoto = ProfilePhoto;
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ProfilePhoto.prototype, "fileId", void 0);
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ProfilePhoto.prototype, "optimizedFileId", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsOptional)(),
    transformToDate_1.TransformToDate,
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Date)
], ProfilePhoto.prototype, "acceptedAt", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsOptional)(),
    transformToDate_1.TransformToDate,
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Date)
], ProfilePhoto.prototype, "declinedAt", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ProfilePhoto.prototype, "declinationReason", void 0);
exports.ProfilePhoto = ProfilePhoto = ProfilePhoto_1 = __decorate([
    (0, class_transformer_1.Exclude)()
], ProfilePhoto);
//# sourceMappingURL=ProfilePhoto.js.map